export enum DoorTypes {
  NO_READERS = 'NO_READERS',
  SINGLE_READER = 'SINGLE_READER',
  DOUBLE_READER = 'DOUBLE_READER',
}
